import { Component } from '@angular/core';
import { AppSettings } from 'app/app-settings';

@Component({
  selector: 'app-calendar-week-skeleton-view',
  templateUrl: './calendar-week-skeleton-view.component.html',
  styleUrls: ['./calendar-week-skeleton-view.component.css']
})
export class CalendarWeekSkeletonViewComponent {

}
